export default __webpack_public_path__ + "static/media/aboutMe.e467c63b.md";